// @flow

import React from 'react';
import Box from 'components/Box';
import { RichTextHeadline, Body } from 'components/Text';
import Video from 'components/Video';
import type { VideoBlockData } from 'api/cms';

const VideoBlock = ({
  blockIndex,
  data: { headline, subtitle, videoUrl },
  fullWidthLayout
}: {
  blockIndex: number,
  data: VideoBlockData,
  fullWidthLayout?: boolean
}) => (
  <Box>
    {(headline || subtitle) && (
      <Box mb={48}>
        {headline && (
          <RichTextHeadline textAlign={fullWidthLayout ? 'center' : 'left'}>
            {headline}
          </RichTextHeadline>
        )}
        {subtitle && (
          <Body
            analyticsData={{
              eventName: 'CMS Block',
              eventProperties: {
                block_position: blockIndex,
                block_type: 'Video'
              }
            }}
            textAlign={fullWidthLayout ? 'center' : 'left'}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}
      </Box>
    )}
    <Video prefix="cms-embed" url={videoUrl} />
  </Box>
);

export default VideoBlock;
